let styleDiv = { justifyContent: "start" };
let styleIcons = { marginRight: "25px", color: "var(--main)" }

export default [
    { text: <div style={styleDiv}> <i className="fas fa-keyboard" style={styleIcons}></i> Text</div>, value: "keyword" },
    { text: <div style={styleDiv}> <i className="fas fa-dice-six" style={styleIcons}></i> Number</div>, value: "integer" },
    { text: <div style={styleDiv}> <i className="fas fa-th-large" style={styleIcons}></i> Array</div>, value: "text" },
    //{ text: <div style={styleDiv}> <i className="fas fa-calendar-alt" style={styleIcons}></i> Date</div>, value: "date" },
]

export function getNameTypeByType(type) {
    let res = "";
    switch (type) {
        case "keyword":
            res = "Text"
            break;
        case "integer":
            res = "Number"
            break;
        case "text":
            res = "Array"
            break;
            /*
        case "date":
            res = "Date"
            break;
            */
    }
    return res;
}